import React from 'react';
import p from 'prop-types';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import styled from 'styled-components';

const themeColorForCode = ({code, theme}) => theme.colors.alarm[code];

const StyledChip = styled(Chip)`
  background-color: ${themeColorForCode};
  color: white;
  font-weight: bold;
`;

const StyledAvatar = styled(Avatar)`
  color: white;
  background-color: ${themeColorForCode};
  filter: brightness(0.85);
`;

const CodeChip = ({code}) => (
  <StyledChip
    code={code}
    label={code}
    avatar={<StyledAvatar code={code}>{code[0].toUpperCase()}</StyledAvatar>}
  />
);

CodeChip.propTypes = {
  code: p.oneOf(['yellow', 'orange', 'red', 'black']).isRequired,
};

export default CodeChip;
